import axiosInstance from '../utils/axiosConfig'
import { ACCOUNT_API_URL } from '../constant/apiUrls';

// const headers = {
//   'Content-Type': 'application/json'
// }

export const CertificationCreate = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.certificateCreate, body)
}

export const CertificationUpdate = (queryParams, body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.UpdateCertificate, body, {
      params: queryParams,
    })

}
export const UserReviewList = (queryParams) => {
  return axiosInstance.get(`${ACCOUNT_API_URL.userReviewList}?id=${queryParams?.id}&job_post=${queryParams?.job_post}`)
}
export const UserReviewCreate = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.userReviewCreate, body)
}
export const CertificationView = (queryParams) => {
  return axiosInstance
    .get(ACCOUNT_API_URL.viewCertification, queryParams)

}

export const PostJobCreate = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.postJob, body)
}
export const PostJobList = (queryParams) => {
  return axiosInstance
    .get(ACCOUNT_API_URL.listJob, { params: queryParams })
}
export const PostJobListFilter = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.listJobFilter, body)
}
export const CertificationListFilter = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.certificationFilter, body)
}
export const PostJobView = (queryParams) => {
  return axiosInstance
    .get(ACCOUNT_API_URL.viewJob, queryParams)

}

export const PostJobUpdate = (queryParams, body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.UpdateJob, body, {
      params: queryParams,
    })

}

export const PostJobStatus = (body) => {
  return axiosInstance
    .put(ACCOUNT_API_URL.statusJob, body)
}


export const CertificationStatus = (body) => {
  return axiosInstance
    .put(ACCOUNT_API_URL.statusCertificate, body)
}



export const UserProfileUpdate = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.updateUserProfile, body)
}

export const PostJobDelete = (params) => {
  return axiosInstance
    .put(ACCOUNT_API_URL.deleteJob, null, { params })
}

export const JobCategoryTypes = (params) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.JobCategoryList, null, { params })
}
export const JobCertification = (params) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.JobCertificationList, null, { params })
}
export const JobQualification = (params) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.JobQualificationsList, null, { params })
}

export const JobSkillSet = (params) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.JobSkillList, null, { params })
}

export const createNewSkill = (params) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.CreateNewSkills, params)
}
export const createNewCertification = (params) => {
  return axiosInstance.post(ACCOUNT_API_URL.CreateNewCertification, params)
}
export const createNewQualification = (params) => {
  return axiosInstance.post(ACCOUNT_API_URL.CreateNewQualification, params)
}
export const JobApplicationList = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.jobApplicationList, body)
}
export const PaymentValidate = (body = {}) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.jobPostPayementSubmit, body)
}
export const CertificatePaymentValidate = (body = {}) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.certificatePayementSubmit, body)
}
export const JobApplicationView = (id) => {
  return axiosInstance
    .get(ACCOUNT_API_URL.jobApplicationView, { params: { 'id': id } })

}


export const CertificateAppliedView = (id) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.certificateAppliedView,null, { params: { 'id': id } })

}



export const JobApplicationDetails = (body) => {
  return axiosInstance
    .get(ACCOUNT_API_URL.jobApplicationView, body)

}

export const partTimerAcceptReject = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.jobApplicationAcceptRejectParttime, body)

}

export const JobApplyStatus = (data) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.jobApplyStatus, data)
}

export const ApplicationPayment = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.applicationPayment, body)
}
export const ApplicationAccept = (data) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.applicationAccept, data)
}

export const EmployerTag = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.employerTag, body)
}

export const EmployeeTag = (data) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.employeeTag, data)
}

export const CertificationCourseList = (queryParams) => {
  return axiosInstance
    .get(ACCOUNT_API_URL.certificationCourseList, { params: queryParams })
}

export const CertificationCourseApplicationList = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.certificationCourseApplicationList, { body })
}

export const DistributeCertificate = (data) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.distributeCertificate, data)
}

export const EmployeeList = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.EmployeeList, body)
}

export const GroupsList = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.GroupsList, body)
}

export const GroupsCreate = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.GroupsCreate, body)
}

export const GroupsUpdate = (body) => {
  return axiosInstance
    .put(ACCOUNT_API_URL.GroupsUpdate, body)
}

export const GroupsView = (id) => {
  return axiosInstance
    .get(`${ACCOUNT_API_URL.GroupsView}/?id=${id}`)
}

export const EmployeeProfile = (_id) => {
  return axiosInstance
    .get(ACCOUNT_API_URL.employeeProfileGet)
}

export const RemovePhoto = () => {
  return axiosInstance
    .post(ACCOUNT_API_URL.removePhoto)
}
export const parttimerUpdateJobIncomplete = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.updateParttimerJobIncomplete, body)
}
export const employerUpdateJobIncomplete = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.updateEmployerJobIncomplete, body)
}
